// © Microsoft Corporation. All rights reserved.

import PageBase from "./PageBase";

export default PageBase;
export * from "./PageBase";
